export default "__VITE_ASSET__BoBvb012__"